/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";


const LinkColor={
    color: '#000'
}
// @material-ui/icons
import {
  Apps,
  CloudDownload,
  Dashboard,
  BarChart,
  People,
  Assignment,
  FormatQuote
} from "@material-ui/icons";

// core components
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-kit-react/components/headerLinksStyle.jsx";

function HeaderLinks({ ...props }) {
  const { classes } = props;
 return (
    <List className={classes.list}>

    <ListItem className={classes.listItem}>
    <Link to="/" style={LinkColor} >
        <Button
         color="white"
          target="_blank"
          className={classes.navLink}
        >
          <Dashboard className={classes.icons} /> Home
        </Button>
</Link>
</ListItem>
        <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Services"
          buttonProps={{
            className: classes.navLink,
            color: "white"
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link to="/civil" className={classes.dropdownLink}>
              Civil & Structure
            </Link>,
            <Link to="/arch" className={classes.dropdownLink}>
              Architectural
            </Link>,
            <Link to="/mech" className={classes.dropdownLink}>
              Mechanical & Electrical (M&E)
            </Link>,
            <Link to="/ict" className={classes.dropdownLink}>
              ICT
            </Link>,
            <Link to="/port" className={classes.dropdownLink}>
              Port Operation
            </Link>,
            <Link to="/oil" className={classes.dropdownLink}>
              Oil & Gas
            </Link>
          ]}
        />

      </ListItem>

       <ListItem className={classes.listItem}>
         <Link to="/projects" style={LinkColor} >
        <Button
          color="white"
          target="_blank"
          className={classes.navLink}
        >
          <BarChart className={classes.icons} /> Projects
        </Button>
         </Link> 
         </ListItem>
     
      <ListItem className={classes.listItem}>

        <Link to="/about" style={LinkColor}>
        <Button
          color="white"
          target="_blank"
          className={classes.navLink}
          onClick={window.scrollTo(0, 0)}
        >
          <People className={classes.icons} /> About Us 
        </Button>
        </Link>
        </ListItem>
      
      <ListItem className={classes.listItem}>   
      <Link to="/contact" style={LinkColor}>
        <Button
          color="white"
          target="_blank"
          className={classes.navLink}
        >
          <Assignment className={classes.icons} /> Contact
        </Button>
          </Link>
        </ListItem>
      
   
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-twitter"
          title="Follow us on twitter"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            href="https://twitter.com/MGEC15"
            target="_blank"
            color="transparent"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-twitter"} />
          </Button>
        </Tooltip>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-facebook"
          title="Follow us on facebook"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://www.facebook.com/pages/Mgec-Myanmar/497773167379677"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-facebook"} />
          </Button>

        </Tooltip>
        
          </ListItem>
          </List>


  );
}

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx